<template>
    <div>
        <base-chats :data="data" :loading="loading" :isAll="true" @search="search($event)" @onScrollEnd="onScrollEnd()" />
        <portal to="app-main-bar">
            <v-btn class="mr-2" color="secondary" @click="showConfigDialog = true">Настроить</v-btn>
            <v-btn color="secondary" @click="fetchNumbers()">Обновить</v-btn>
        </portal>
        <config-dialg v-model="showConfigDialog" :filters="filters" @filters="filters = $event" />
    </div>
</template>

<script>
export default {
    components: {
        baseChats: () => import("./baseChats.vue"),
        configDialg: () => import("./configDialog.vue"),
    },
    data() {
        return {
            showConfigDialog: false,
            loading: false,
            data: [],
            filters: {},
            pager: {},
            isTheEnd: null,
        }
    },
    created() {
        this.fetchNumbers();
    },
    watch: {
        showConfigDialog() {
            if (!this.showConfigDialog) {
                this.fetchNumbers();
            }
        }
    },
    methods: {
        search(number) {
            if (number) {
                this.filters = Object.assign({}, this.filters, {
                    "wa_number": { "condition": "LIKE", "value": "%" + number + "%" }
                })
            } else {
                this.filters = this.filters = Object.assign({}, this.filters, {
                    "wa_number": undefined
                })
            }
            this.fetchNumbers();
        },
        onScrollEnd() {
            if (!this.isTheEnd && !this.loading) {
                this.pager.page++;
                this.fetchNumbers(true);
            }

        },
        async fetchNumbers(append = false) {
            try {
                this.loading = true;
                if (!append) {
                    this.data = [];
                    this.pager = {limit: 50, page: 0};
                    this.isTheEnd = false;
                }
                const response = await this.$axios.get("/wa/messages_clients/dialogs", { params: { filters: JSON.stringify(this.filters), pager: JSON.stringify(this.pager) } });
                if (append) {
                    this.data = [...this.data, ...response.data.data];
                } else {
                    this.data = response.data.data;
                    this.pager = response.data.pager;
                }
                if (response.data.data.length < this.pager.limit) this.isTheEnd = true;
                this.loading = false;
            } catch (error) {
                console.error(error);

            }
        }
    }
}
</script>